import deepcopy from 'deepcopy';
import {
  type DeviceFilter,
  DeviceSelectValues,
} from '../DeviceFamilyFilter.types';

export function findFilter(filters: DeviceFilter[], id: string) {
  let index = 0;

  while (index < filters.length) {
    const currentFilter = filters[index];

    if (currentFilter.id === id) {
      return currentFilter;
    }

    if (currentFilter.children != null) {
      const filter = findFilter(currentFilter.children, id);
      if (filter != null) return filter;
    }

    index++;
  }

  return null;
}

export function findAndUpdateFilter(
  filters: DeviceFilter[],
  id: string,
  updates: Partial<DeviceFilter>,
) {
  // ===================================================================
  // HELPERS
  //
  // These helper functions modify filter objects in place
  // and should not be used outside the scope of findAndUpdateFilter.
  // ===================================================================

  function updateParent(filters: DeviceFilter[], filter: DeviceFilter) {
    if (filter.parent != null) {
      const parentFilter = findFilter(filters, filter.parent);
      const selectedChildren = parentFilter.children.filter(
        (child: DeviceFilter) => child.value === DeviceSelectValues.CHECKED,
      );

      if (selectedChildren.length === parentFilter.children.length) {
        parentFilter.value = DeviceSelectValues.CHECKED;
      } else if (selectedChildren.length > 0) {
        parentFilter.value = DeviceSelectValues.INDETERMINATE;
      } else {
        parentFilter.value = DeviceSelectValues.UNCHECKED;
      }
    }
  }

  function updateChildren(filter: DeviceFilter) {
    if (filter.children != null) {
      filter.children = filter.children.map((child) => ({
        ...child,
        ...updates,
      }));
    }
  }

  // ===================================================================
  // FIND AND UPATE
  // ===================================================================

  const newFilters = deepcopy(filters);
  const filter = findFilter(newFilters, id);

  if (!filter) {
    return newFilters;
  }

  Object.assign(filter, updates);
  updateParent(newFilters, filter);
  updateChildren(filter);

  return newFilters;
}
